/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { CustomFilterV2 } from '../../../components/v2';
import { STATUS_FILTER_OPTIONS } from './constants';
import { EXPORT_TIPO_SERVICO_OPTIONS } from '../Digitacao/OperadorNova/constants';

const ExportFilterDialog = ({
  open,
  onClose,
  defaultFilter,
  canScopeDigitadores,
  onExport,
}) => {
  const applied = useMemo(
    () => ({
      ...defaultFilter,
      dateTypes: ['DATA_DIGITACAO'],
    }),
    [defaultFilter],
  );

  return (
    <CustomFilterV2
      variant="dialog"
      open={open}
      onClose={onClose}
      title="Exportar relatório"
      fullWidth
      confirmButtonText="Exportar"
      defaultFilter={applied}
      appliedFilter={applied}
      fields={[
        { field: 'useDates', useDateTypes: true, useDateTypesReadOnly: true },
        { field: 'useCodigo', codigoLabel: 'Código NSIR', md: 4, xs: 12 },
        { field: 'useMalha', md: 4, xs: 12 },
        { field: 'usePolo', md: 4, xs: 12 },
        { field: 'useSubestacao', md: 4, xs: 12 },
        { field: 'useAlimentador', md: 4, xs: 12 },
        {
          field: 'useSearchSelect',
          key: 'tipoServicos',
          label: 'Tipo de Serviço',
          multiSelect: true,
          md: 6,
          xs: 12,
          options: EXPORT_TIPO_SERVICO_OPTIONS,
        },
        { field: 'useSubTipoServico', md: 6, xs: 12 },
        {
          field: 'useNsirStatus',
          customStatus: STATUS_FILTER_OPTIONS,
          multiSelect: true,
          md: 12,
          xs: 12,
        },
        {
          field: 'useDigitador',
          multiSelect: true,
          disabled: !canScopeDigitadores,
          md: 12,
          xs: 12,
        },
      ]}
      onFilter={(filterData) => {
        onExport({
          ...filterData,
          dateTypes: ['DATA_DIGITACAO'],
        });
        onClose();
      }}
    />
  );
};

ExportFilterDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  defaultFilter: PropTypes.object.isRequired,
  canScopeDigitadores: PropTypes.bool,
  onExport: PropTypes.func.isRequired,
};

ExportFilterDialog.defaultProps = {
  canScopeDigitadores: true,
};

export default ExportFilterDialog;
